if (!customElements.get("tanatel-installments")) {
  customElements.define(
    "tanatel-installments",
    class TanatelInstallments extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector("dialog");
        this.price = Number(this.dataset.price || 0);
        this.currency = this.dataset.currency || "SAR";
        this.locale = this.dataset.locale === "ar" ? "ar-SA" : "en-SA";
        this.counts = {
          tabby: Number(this.dataset.tabbyCount || 4),
          tamara: Number(this.dataset.tamaraCount || 4),
        };

        this.onClick = this.handleClick.bind(this);
        this.onDialogClick = this.handleDialogClick.bind(this);
        this.addEventListener("click", this.onClick);
        this.dialog?.addEventListener("click", this.onDialogClick);
        this.renderAmounts();

        const productId = this.dataset.productId;
        if (window.MinimogEvents?.subscribe && productId) {
          this.unsubscribe = window.MinimogEvents.subscribe(
            `${productId}__VARIANT_CHANGE`,
            (variant) => {
              if (!variant || typeof variant.price !== "number") return;
              this.price = variant.price;
              this.renderAmounts();
            },
          );
        }
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.onClick);
        this.dialog?.removeEventListener("click", this.onDialogClick);
        this.unsubscribe?.();
      }

      format(cents) {
        return new Intl.NumberFormat(this.locale, {
          style: "currency",
          currency: this.currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(cents / 100);
      }

      renderAmounts() {
        this.querySelectorAll("[data-installment-total]").forEach((node) => {
          node.textContent = this.format(this.price);
        });
        Object.entries(this.counts).forEach(([provider, count]) => {
          const amount = count > 0 ? this.price / count : this.price;
          this.querySelectorAll(
            `[data-installment-amount="${provider}"]`,
          ).forEach((node) => {
            node.textContent = this.format(amount);
          });
        });
      }

      handleClick(event) {
        const openButton = event.target.closest("[data-installment-open]");
        const tabButton = event.target.closest("[data-installment-tab]");
        const closeButton = event.target.closest("[data-installment-close]");

        if (openButton) {
          this.open(openButton.dataset.installmentOpen);
        } else if (tabButton) {
          this.selectProvider(tabButton.dataset.installmentTab);
        } else if (closeButton) {
          this.dialog?.close();
        }
      }

      handleDialogClick(event) {
        if (event.target === this.dialog) this.dialog.close();
      }

      open(provider) {
        if (!this.dialog) return;
        this.selectProvider(provider);
        if (typeof this.dialog.showModal === "function") {
          this.dialog.showModal();
        } else {
          this.dialog.setAttribute("open", "");
        }
      }

      selectProvider(provider) {
        this.querySelectorAll("[data-installment-tab]").forEach((tab) => {
          const active = tab.dataset.installmentTab === provider;
          tab.setAttribute("aria-selected", String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.querySelectorAll("[data-installment-panel]").forEach((panel) => {
          panel.hidden = panel.dataset.installmentPanel !== provider;
        });
      }
    },
  );
}

